var DESK_QUIZ_STORAGE_KEY = 'deskQuizAnswers';
var DESK_QUIZ_QUESTIONS_KEY = 'deskQuizQuestions';
var DESK_QUIZ_SESSION_KEY = 'deskQuizSession';
var DESK_QUIZ_QUEUE_KEY = 'deskQuizQueue';
var DESK_QUIZ_SENT_KEY = 'deskQuizSent';
// the one thing that outlives the session: an address we have already collected
var DESK_QUIZ_EMAIL_KEY = 'deskQuizEmail';
var DESK_QUIZ_EMAIL_SKIPPED_KEY = 'deskQuizEmailSkipped';
var DESK_QUIZ_EMAIL_ROUTES_KEY = 'deskQuizEmailRoutes';
var DESK_QUIZ_PENDING_KEY = 'deskQuizPendingSubscribe';
var DESK_QUIZ_EMAIL_VISIBLE_KEY = 'deskQuizEmailVisible';
var DESK_QUIZ_IDENTIFIED_KEY = 'deskQuizIdentified';
var DESK_QUIZ_SKIP_FROM_KEY = 'deskQuizSkipFrom';
var DESK_QUIZ_LOADER_KEY = 'deskQuizLoaderSeen';
var DESK_QUIZ_INLINE_SENT_KEY = 'deskQuizInlineSent';
var DESK_QUIZ_TRAIL_KEY = 'deskQuizTrail';
var DESK_QUIZ_KEYS_KEY = 'deskQuizKeys';
var DESK_QUIZ_EVENT_NAME = 'Quiz - Submitted by profile';
var DESK_QUIZ_KLAVIYO_URL = 'https://a.klaviyo.com/client/events/';
var DESK_QUIZ_KLAVIYO_REVISION = '2026-07-15';
var deskQuizBackTrapArmed = false;
 
$(document).ready(initQuiz);

$(window).on('pageshow', function (event) {
  if (event.originalEvent && event.originalEvent.persisted) {
    initQuiz();
  }
});

function initQuiz() {
  updateQuizTrail();
  computeQuizTiers();
  clearQuizOptionLoaders();
  runQuizLoader();
  filterQuizOffers();
  placeQuizLoader();
  orderQuizSwatches();
  markQuizSoldOutOffers();
  bindQuizSwatches();
  loadQuizOfferVariants();
  preloadQuizOfferImages();
  applyQuizSkippedBackLink();
  syncQuizBackLink();
  syncQuizProgress();
  filterQuizCards();
  cacheQuizEmailRoutes();
  applyQuizRoutes();
  skipQuizEmailStep();
  applyQuizEmailSkipLinks();
  restoreQuizSelection();
  bindQuizOptions();
  bindQuizSelects();
  bindQuizDropdowns();
  bindQuizEmail();
  bindQuizHelp();
  bindQuizModal();
  bindQuizRetake();
  bindQuizOfferCart();
  bindQuizOptionsLink();
  bindQuizOosPopup();
  bindQuizBackTrap();
  bindQuizConsent();
  resolveQuizIdentified();
  initQuizInlineEmail();
  flushQuizPendingSubscribe();
  trackQuizPage();
  fillQuizReviewCounts();
}

function fillQuizReviewCounts() {
  if (!window.DeskReviewCounts) return;

  $('[data-quiz-review-count]').each(function () {
    var $count = $(this);
    var group = $.trim($count.closest('[data-product-group]').attr('data-product-group') || '');

    if (!group) return;

    window.DeskReviewCounts.fetchCount(group).then(function (count) {
      if (!count) return;

      $count.text('(' + count + ')');
    });
  });
}


function bindQuizConsent() {
  $(document)
    .off('visitorConsentCollected.deskQuiz')
    .on('visitorConsentCollected.deskQuiz', function () {
      if (getQuizTrackMode() === 'session') trackQuizPage();
    });
}

var DESK_QUIZ_PDP_ORIGIN_KEY = 'deskQuizPdpOrigin';

function bindQuizOptionsLink() {
  $(document)
    .off('click.deskQuizOptions')
    .on('click.deskQuizOptions', '[data-quiz-options-link]', function () {
      try {
        sessionStorage.setItem(DESK_QUIZ_PDP_ORIGIN_KEY, '1');
      } catch (e) {}

      trackQuizOptions();
    });
}

function bindQuizOfferCart() {
  $(document)
    .off('click.deskQuizOffer')
    .on('click.deskQuizOffer', '[data-quiz-offer-add]', function () {
      var $button = $(this);
      var items = getQuizOfferItems($button);

      if ($button.hasClass('soldOut')) {
        openQuizOosPopupForOffer();
        return;
      }

      if (!items.length || $button.hasClass('loading')) return;

      setQuizOfferAdding($button, true);

      // Analytics and the A/B attribute are not worth a lost sale: if either
      // throws, the request still has to go out.
      try {
        trackQuizAddToCart();
        if (window.deskSetCartAttributes) window.deskSetCartAttributes({ 'Quiz offer page': 'Yes' });
      } catch (e) {
        console.error('Quiz offer pre-add error:', e);
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              console.error('Quiz offer add rejected:', response.status, body);
            });
          }

          if (window.refreshCartDrawer) window.refreshCartDrawer();
        })
        .catch(function (e) {
          console.error('Quiz offer add error:', e);
        })
        .then(function () {
          setQuizOfferAdding($button, false);
        });
    });
}

function getQuizOfferItems($button) {
  return ($button.attr('data-quiz-offer-add') || '')
    .split(',')
    .map(function (id) {
      return $.trim(id);
    })
    .filter(function (id) {
      return id !== '';
    })
    .map(function (id) {
      // the quantity is what makes the volume discount apply at checkout
      return { id: pickQuizOfferVariant(id), quantity: getQuizOfferQuantity($('.desk_quiz--offer')) };
    });
}

// Add the colour and size the answers point at, not the product default.
function pickQuizOfferVariant(defaultId) {
  var match = findQuizOfferVariant($('.desk_quiz-offer__card[data-quiz-offer-variant="' + defaultId + '"]'));

  return match && match.id ? String(match.id) : defaultId;
}

// The spinner replaces the label, the way every other button in the quiz works.
// The adding label stays as the accessible name while it spins.
function setQuizOfferAdding($button, adding) {
  if (adding) {
    $button
      .addClass('loading')
      .attr('aria-busy', 'true')
      .attr('aria-label', $button.closest('.desk_quiz').attr('data-quiz-adding-label') || '');
    return;
  }

  $button.removeClass('loading').removeAttr('aria-busy').removeAttr('aria-label');
}

function bindQuizRetake() {
  $(document)
    .off('click.deskQuizRetake')
    .on('click.deskQuizRetake', '[data-quiz-retake]', function () {
      clearQuizAnswers();
    });
}

function updateQuizTrail() {
  var path = window.location.pathname;
  var trail = readQuizTrail();
  var index = $.inArray(path, trail);

  if (getQuizStep() === '1') {
    dropQuizAnswersForPaths(trail, path);
    trail = [path];
  } else if (index > -1) {
    // going back un-asks everything after this question, so its answers must go
    // too — otherwise a skipped branch keeps driving the result
    dropQuizAnswersForPaths(trail.slice(index + 1), path);
    trail = trail.slice(0, index + 1);
  } else {
    trail.push(path);
  }

  rememberQuizPageKeys();

  try {
    sessionStorage.setItem(DESK_QUIZ_TRAIL_KEY, JSON.stringify(trail.slice(-20)));
  } catch (e) {}
}

function readQuizKeyMap() {
  var map;

  try {
    map = JSON.parse(sessionStorage.getItem(DESK_QUIZ_KEYS_KEY) || '{}');
  } catch (e) {
    return {};
  }

  return map && typeof map === 'object' ? map : {};
}

// which answer this page writes, so a later visit can undo it
function rememberQuizPageKeys() {
  var $quiz = $('.desk_quiz');
  var keys = [];
  var map;

  $quiz.find('[data-quiz-select]').each(function () {
    var name = $.trim($(this).attr('name') || '');

    if (name) keys.push(name);
  });

  if (!keys.length && $.trim($quiz.attr('data-quiz-key') || '')) keys.push($.trim($quiz.attr('data-quiz-key')));
  if (!keys.length) return;

  map = readQuizKeyMap();
  map[window.location.pathname] = keys;

  try {
    sessionStorage.setItem(DESK_QUIZ_KEYS_KEY, JSON.stringify(map));
  } catch (e) {}
}

function dropQuizAnswersForPaths(paths, keepPath) {
  var map = readQuizKeyMap();
  var answers = getQuizAnswers();
  var dropped = false;

  $.each(paths || [], function (i, path) {
    if (path === keepPath) return;

    $.each(map[path] || [], function (j, key) {
      if (answers['step-' + key] === undefined) return;

      delete answers['step-' + key];
      dropped = true;
    });
  });

  if (!dropped) return;

  try {
    sessionStorage.setItem(DESK_QUIZ_STORAGE_KEY, JSON.stringify(answers));
  } catch (e) {}
}

function readQuizTrail() {
  var trail;

  try {
    trail = JSON.parse(sessionStorage.getItem(DESK_QUIZ_TRAIL_KEY) || '[]');
  } catch (e) {
    return [];
  }

  return $.isArray(trail) ? trail : [];
}

function getQuizTrailPrev() {
  var trail = readQuizTrail();

  if (trail.length < 2 || trail[trail.length - 1] !== window.location.pathname) return '';

  return trail[trail.length - 2];
}

function syncQuizBackLink() {
  var prevUrl = getQuizTrailPrev() || $('.desk_quiz').attr('data-quiz-prev');

  $(document).off('click.deskQuizBack');

  if (prevUrl) {
    $('.desk_quiz-back').attr('href', prevUrl);
    return;
  }

  $(document).on('click.deskQuizBack', '.desk_quiz-back', function (event) {
    if (history.length <= 1) return;

    event.preventDefault();
    history.back();
  });
}

function syncQuizProgress() {
  var $quiz = $('.desk_quiz');
  var step = parseInt($quiz.attr('data-quiz-step'), 10);
  var total = parseInt($quiz.attr('data-quiz-total'), 10);
  var byFlow = quizStepsForFlow($quiz.attr('data-quiz-steps-by-flow'));

  if (byFlow) {
    step = byFlow.step;
    total = byFlow.total;
  }

  if (!step || !total) return;

  var done = Math.min(step - 1, total);
  var percent = Math.round((done * 100) / total);
  var $label = $('.desk_quiz-progress__label');

  $('.desk_quiz-progress__value').attr('stroke-dashoffset', (100 - percent) * 0.659734);
  $label.text(percent + '% ' + ($label.attr('data-quiz-progress-label') || ''));
}

// one line per flow, e.g. "setup = 8 of 9" — the same page sits at a different
// position depending on which flow walked into it
function quizStepsForFlow(spec) {
  var flow = getQuizFlow();
  var lines = $.trim(spec || '').split(';');
  var found = null;
  var i;
  var parts;
  var at;

  if (!flow || !lines.length) return null;

  for (i = 0; i < lines.length; i++) {
    parts = $.trim(lines[i]).split('=');

    if (parts.length !== 2 || $.trim(parts[0]) !== flow) continue;

    at = $.trim(parts[1]).split(/\s+of\s+/);

    if (at.length === 2) found = { step: parseInt(at[0], 10), total: parseInt(at[1], 10) };
  }

  return found && found.step && found.total ? found : null;
}

function getQuizFlow() {
  return getQuizAnswers()['step-flow'] || '';
}

function getQuizRouteUrl() {
  var flow = getQuizFlow();
  var url = '';

  if (!flow) return '';

  $('.desk_quiz-route').each(function () {
    if ($(this).attr('data-quiz-flow') === flow) url = $(this).attr('data-quiz-url');
  });

  return url;
}

function applyQuizRoutes() {
  var url = getQuizRouteUrl();

  if (!url) return;

  $('.desk_quiz-option, .desk_quiz-card').each(function () {
    var $option = $(this);

    if ($option.attr('data-quiz-own-url') === 'true') return;
    if ($option.is('a')) $option.attr('href', url);
  });

  $('.desk_quiz__continue, .desk_quiz-email__skip').filter('a').attr('href', url);
  $('.desk_quiz-email, .desk_quiz-selects').attr('data-quiz-next', url);
}

function filterQuizCards() {
  var $section = $('.desk_quiz--cards');
  var filterBy = $section.attr('data-quiz-filter-by');
  var answer = filterBy ? getQuizAnswers()['step-' + filterBy] : '';

  if (answer && !$.isArray(answer)) applyQuizCardFilter(answer);

  hideQuizCardsByRule();
  syncQuizCardGroups();

  $section.removeClass('filtering');
}

// A card can also rule itself out of a whole branch — Midnight Blue is not made
// in SitPro, so the answers that resolve the chair to SitPro hide it. Runs after
// the tag filter, whose fail-open path un-hides everything.
// Each tier is defined once on the quiz header and resolved here, so the
// questions and the results page can never disagree about which model won.
function computeQuizTiers() {
  var $header = $('.desk_quiz-header');

  if (!$header.length) return;

  var answers = getQuizAnswers();

  saveQuizTier('desk-tier', $header.attr('data-quiz-desk-tier-rule'), answers);
  saveQuizTier('chair-tier', $header.attr('data-quiz-chair-tier-rule'), answers);
}

function saveQuizTier(key, rules, answers) {
  rules = $.trim(rules || '');

  if (!rules) return;

  saveQuizAnswer(key, quizOfferRulesMatch(rules, answers) ? 'pro' : 'one');
}

function hideQuizCardsByRule() {
  var answers = getQuizAnswers();

  $('.desk_quiz-card[data-quiz-hide-rules]').each(function () {
    var $card = $(this);
    var rules = $.trim($card.attr('data-quiz-hide-rules') || '');

    // an empty rule set matches everything, which would hide the card outright
    if (rules && quizOfferRulesMatch(rules, answers)) $card.addClass('hidden');
  });

  // the inverse: these cards are the alternative set and stay out until their
  // rules match, e.g. the SitPro colours once the chair resolves to SitPro
  $('.desk_quiz-card[data-quiz-show-rules]').each(function () {
    var $card = $(this);
    var rules = $.trim($card.attr('data-quiz-show-rules') || '');

    if (rules && !quizOfferRulesMatch(rules, answers)) $card.addClass('hidden');
  });
}

function applyQuizCardFilter(answer) {
  var matched = 0;

  $('.desk_quiz-card').each(function () {
    var $card = $(this);
    var tags = ($card.attr('data-quiz-tags') || '').split(',');
    var show = false;

    for (var i = 0; i < tags.length; i++) {
      if ($.trim(tags[i]) === answer) show = true;
    }

    $card.toggleClass('hidden', !show);

    if (show) matched++;
  });

  if (!matched) $('.desk_quiz-card').removeClass('hidden');
}

function syncQuizCardGroups() {
  $('.desk_quiz-cards__group').each(function () {
    var $group = $(this);

    $group.toggleClass('hidden', $group.find('.desk_quiz-card').not('.hidden').length === 0);
  });
}


function filterQuizOffers() {
  var $offers = $('.desk_quiz--offer[data-quiz-offer-select="true"]');
  var $chosen;

  if (!$offers.length) return;

  // the theme editor needs every offer visible and editable
  if (window.Shopify && window.Shopify.designMode) {
    $offers.removeClass('filtering');
    return;
  }

  $chosen = findQuizOffer($offers);
  recordQuizOfferChoice($offers, getQuizAnswers(), $chosen.attr('data-quiz-offer-key') || '(none)');

  $offers.not($chosen).remove();
  $chosen.removeClass('filtering');

  saveQuizAnswer('offer', $chosen.attr('data-quiz-offer-key') || '');
  trackQuizAnswer(getQuizStep(), $chosen.attr('data-quiz-offer-key') || 'none');
}

// first match in section order, then the fallback, then the first offer
function findQuizOffer($offers) {
  var answers = getQuizAnswers();
  var $match = $();
  var $fallback = $();

  $offers.each(function () {
    var $offer = $(this);

    if ($offer.attr('data-quiz-offer-fallback') === 'true') {
      if (!$fallback.length) $fallback = $offer;
      return;
    }

    if (!$match.length && quizOfferMatches($offer, answers)) $match = $offer;
  });

  if ($match.length) return $match;
  if ($fallback.length) return $fallback;

  return $offers.first();
}

function quizOfferMatches($offer, answers) {
  var flows = splitQuizValues($offer.attr('data-quiz-offer-flow'));

  if (flows.length && $.inArray(answers['step-flow'] || '', flows) === -1) return false;

  return quizOfferRulesMatch($offer.attr('data-quiz-offer-rules'), answers);
}

// lines are ANDed; a line reading "or" starts an alternative set
function quizOfferRulesMatch(rules, answers) {
  var lines = (rules || '').split(';');
  var setMatches = true;
  var matched = false;
  var line;
  var i;

  for (i = 0; i < lines.length; i++) {
    line = $.trim(lines[i]);

    if (line === '') continue;

    if (line.toLowerCase() === 'or') {
      if (setMatches) matched = true;
      setMatches = true;
      continue;
    }

    if (!quizOfferRuleMatches(line, answers)) setMatches = false;
  }

  if (setMatches) matched = true;

  return matched;
}

// one line of "step: value, value"
function quizOfferRuleMatches(rule, answers) {
  var parts = rule.split(':');
  var key = $.trim(parts[0]);
  var values = splitQuizValues(parts[1]);
  var answer = answers['step-' + key];
  var i;

  if (!key || !values.length) return false;
  if (answer === undefined || answer === null || answer === '') return false;

  // multi-select answers match when any picked value is listed
  if ($.isArray(answer)) {
    for (i = 0; i < answer.length; i++) {
      if ($.inArray(answer[i], values) > -1) return true;
    }

    return false;
  }

  return $.inArray(String(answer), values) > -1;
}

function orderQuizSwatches() {
  var answers = getQuizAnswers();

  $('[data-quiz-swatches]').each(function () {
    var $row = $(this);
    var $swatches = $row.find('.desk_quiz-offer__swatch');
    var $chosen = $();
    var wanted;

    if (!$swatches.length) return;

    if ($swatches.filter(function () { return !!$(this).attr('data-quiz-swatch-frame'); }).length) {
      orderQuizDeskSwatches($row, $swatches, answers);
      return;
    }

    wanted = resolveQuizRuleValue($row.attr('data-quiz-swatch-rules'), answers, '');

    if (wanted) $chosen = $swatches.filter('[data-quiz-swatch-value="' + wanted + '"]').first();

    $swatches.each(function () {
      var $swatch = $(this);

      if (!$chosen.length && quizSwatchChosen($swatch, answers)) $chosen = $swatch;
    });

    $swatches.filter('[data-quiz-swatch-popular="true"]').prependTo($row);
    prependQuizMaterialSwatches($row, $swatches, answers);

    if (!$chosen.length) return;

    $chosen.prependTo($row).addClass('selected');
    setQuizSwatchLabel($row, $chosen);
    refreshQuizOfferCard($row.closest('.desk_quiz-offer__card'));
  });
}

// desks: "Swatch order" names the row outright, so the frame and material
// filters do not apply — the spec mixes frames within one row
function orderQuizDeskSwatchesInOrder($row, $swatches, order) {
  var $more = $row.find('.desk_quiz-offer__swatch-more');
  var $keep = $();

  $.each(order, function (i, value) {
    $keep = $keep.add($swatches.filter('[data-quiz-swatch-value="' + value + '"]').first());
  });

  $swatches.not($keep).remove();

  if (!$keep.length) {
    $row.closest('.desk_quiz-offer__options').hide();
    syncQuizSwatchMore($row);
    return;
  }

  $.each(order, function (i, value) {
    var $swatch = $keep.filter('[data-quiz-swatch-value="' + value + '"]').first();

    if (!$swatch.length) return;
    if ($more.length) $swatch.insertBefore($more);
    else $swatch.appendTo($row);
  });

  syncQuizSwatchMore($row);

  var $chosen = $row.find('.desk_quiz-offer__swatch').first();

  $row.find('.desk_quiz-offer__swatch').removeClass('selected');
  $chosen.addClass('selected');
  setQuizSwatchLabel($row, $chosen);
  refreshQuizOfferCard($row.closest('.desk_quiz-offer__card'));
}

// desks: "Answers to swatch" picks the first, then the blocks that fit the material and frame
function orderQuizDeskSwatches($row, $swatches, answers) {
  var $offer = $row.closest('.desk_quiz--offer');
  var step = $.trim($offer.attr('data-quiz-material-step') || '');
  var material = step ? answers['step-' + step] : '';
  var order = splitQuizValues(resolveQuizRuleValue($offer.attr('data-quiz-swatch-order'), answers, ''));
  var frame;
  var wanted;
  var $first;
  var $keep;
  var $chosen;

  if (order.length) {
    orderQuizDeskSwatchesInOrder($row, $swatches, order);
    return;
  }

  frame = handleizeQuizValue(resolveQuizRuleValue($offer.attr('data-quiz-frame-rules'), answers, ''));
  wanted = resolveQuizRuleValue($row.attr('data-quiz-swatch-rules'), answers, '');
  $first = wanted ? $swatches.filter('[data-quiz-swatch-value="' + wanted + '"]').first() : $();
  $keep = $swatches.filter(function () {
    var $swatch = $(this);
    var show = $swatch.attr('data-quiz-swatch-show') || 'both';

    if ($swatch.is($first)) return true;
    if (material && !$.isArray(material) && show !== 'both' && show !== String(material)) return false;
    if (frame && $swatch.attr('data-quiz-swatch-frame') !== frame) return false;

    return true;
  });
  $chosen = $first.length ? $first : $keep.first();

  $swatches.not($keep).remove();
  syncQuizSwatchMore($row);

  if (!$keep.length) {
    $row.closest('.desk_quiz-offer__options').hide();
    return;
  }

  $chosen.prependTo($row);
  $row.find('.desk_quiz-offer__swatch').removeClass('selected');
  $chosen.addClass('selected');
  setQuizSwatchLabel($row, $chosen);
  refreshQuizOfferCard($row.closest('.desk_quiz-offer__card'));
}

function prependQuizMaterialSwatches($row, $swatches, answers) {
  var step = $.trim($row.closest('.desk_quiz--offer').attr('data-quiz-material-step') || '');
  var material;

  if (!step) return;

  material = answers['step-' + step];

  if (!material || $.isArray(material)) return;

  $swatches.filter(function () {
    return $(this).attr('data-quiz-swatch-material') === String(material);
  }).prependTo($row);
}

function bindQuizSwatches() {
  $(document)
    .off('mouseenter.deskQuizSwatch touchstart.deskQuizSwatch')
    .on('mouseenter.deskQuizSwatch touchstart.deskQuizSwatch', '.desk_quiz-offer__swatch', preloadQuizSwatchImage)
    .off('click.deskQuizSwatch')
    .on('click.deskQuizSwatch', '.desk_quiz-offer__swatch', function () {
      var $swatch = $(this);
      var $row = $swatch.closest('[data-quiz-swatches]');

      // scoped to this row, so the two products on the multi page don't fight
      $row.find('.desk_quiz-offer__swatch').removeClass('selected');
      $swatch.addClass('selected');
      setQuizSwatchLabel($row, $swatch);
      refreshQuizOfferCard($row.closest('.desk_quiz-offer__card'));

      // picking a sold-out colour opens the popup straight away, as on the PDP
      if ($swatch.hasClass('soldOut')) openQuizOosPopupForOffer();
    });
}

function applyQuizOfferImage($card) {
  var match = findQuizOfferVariant($card);

  if (!match || !match.src) return;

  $card.find('.desk_quiz-offer__image img').attr('src', match.src).removeAttr('srcset');
}

function refreshQuizOfferCard($card) {
  applyQuizOfferImage($card);
  applyQuizOfferPrice($card);
  syncQuizOfferTotal();
  syncQuizOfferAvailability();
  syncQuizSoldOutNote($card);
  syncQuizOptionsLink($card);
  syncQuizOfferSize($card);
}

// desks only: the size is the third option
function syncQuizOfferSize($card) {
  var match = findQuizOfferVariant($card);

  if (!match || match.size === undefined) return;

  $card.find('[data-quiz-offer-size]').text(match.size ? ' ' + match.size : '');
}

function quizVariantSize(title) {
  var parts = String(title || '').split(' / ');

  return parts.length > 2 ? parts[parts.length - 1] : '';
}

function markQuizSoldOutOffers() {
  $('.desk_quiz-offer__card').each(function () {
    markQuizSoldOutSwatches($(this));
  });

  syncQuizOfferAvailability();
}

function markQuizSoldOutSwatches($card) {
  var variants = readQuizOfferVariants($card);
  var label = $.trim($('.desk_quiz--offer').attr('data-quiz-swatch-soldout-label') || '');

  if (!variants) return;

  $card.find('.desk_quiz-offer__swatch').each(function () {
    var $swatch = $(this);
    var match = quizVariantForColour($card, $swatch.attr('data-quiz-swatch-value'));
    var name = $swatch.attr('data-quiz-swatch-label') || '';
    var soldOut = !!match && match.available === false;

    $swatch.toggleClass('soldOut', soldOut);
    $swatch.attr('data-swatch-tooltip', soldOut && label ? name + ' ' + label : name);
  });

  syncQuizSoldOutNote($card);
  syncQuizOptionsLink($card);
}

function syncQuizOptionsLink($card) {
  setQuizOptionsHref($card.find('[data-quiz-options-base]'), $card);
  syncQuizFooterOptionsLink($card.closest('.desk_quiz--offer'));
}

function syncQuizFooterOptionsLink($offer) {
  var $link = $offer.find('[data-quiz-options-footer]');
  var $cards = $offer.find('.desk_quiz-offer__card');
  var base = $link.attr('data-quiz-options-base');
  var desk;
  var chair;
  var params = [];

  if (!$link.length || !base) return;

  desk = findQuizOfferVariant($cards.eq(0));
  chair = $cards.length > 1 ? findQuizOfferVariant($cards.eq(1)) : null;

  if (desk && desk.id) params.push('variant=' + desk.id);
  if (chair && chair.id) params.push('addon=' + chair.id, 'open3d=1');

  $link.attr('href', params.length ? base + (base.indexOf('?') > -1 ? '&' : '?') + params.join('&') : base);
}

function setQuizOptionsHref($link, $card) {
  var base = $link.attr('data-quiz-options-base');
  var match;

  if (!$link.length || !base) return;

  match = findQuizOfferVariant($card);

  if (!match || !match.id) {
    $link.attr('href', base);
    return;
  }

  $link.attr('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + match.id);
}

function syncQuizSoldOutNote($card) {
  var $note = $card.find('[data-quiz-soldout-note]');
  var $selected;
  var name;

  if (!$note.length) return;

  if (!quizOfferCardSoldOut($card)) {
    $note.prop('hidden', true);
    return;
  }

  $selected = $card.find('.desk_quiz-offer__swatch.selected').first();
  name = $selected.attr('data-quiz-swatch-label') || $.trim($card.find('.desk_quiz-offer__options-value').text());

  $note.find('.desk_quiz-offer__soldout-text').text(String($note.attr('data-quiz-soldout-note')).replace('[colour]', name));
  $note.prop('hidden', false);
}

function quizOfferCardSoldOut($card) {
  var match = findQuizOfferVariant($card);

  return !!match && match.available === false;
}

function syncQuizOfferAvailability() {
  var $offer = $('.desk_quiz--offer');
  var $button = $offer.find('[data-quiz-offer-add]');
  var soldOut = false;

  if (!$button.length) return;

  $offer.find('.desk_quiz-offer__card').each(function () {
    if (quizOfferCardSoldOut($(this))) soldOut = true;
  });

  if ($button.hasClass('loading')) return;

  $button.toggleClass('soldOut', soldOut);

  var $label = $button.find('.desk_quiz-offer__add-label');
  var stored = $button.attr('data-quiz-label');

  if (soldOut) {
    if (!stored) $button.attr('data-quiz-label', $label.text());
    $label.text($offer.attr('data-quiz-notify-label') || $label.text());
    return;
  }

  if (stored) {
    $label.text(stored);
    $button.removeAttr('data-quiz-label');
  }
}

function openQuizOosPopupForOffer() {
  var variantId = '';

  $('.desk_quiz--offer .desk_quiz-offer__card').each(function () {
    var $card = $(this);
    var match;

    if (variantId || !quizOfferCardSoldOut($card)) return;

    match = findQuizOfferVariant($card);
    if (match && match.id) variantId = String(match.id);
  });

  if (variantId) openQuizOosPopup(variantId);
}

function openQuizOosPopup(variantId) {
  var $popup = $('.desk_oos-popup-outer');

  if (!$popup.length) return;

  $popup.addClass('active').attr('data-id', variantId);
  $popup.find('.desk_oos-popup-inner').removeClass('submitedSuccess');
  $('body').addClass('desk_quiz-modal-open');
  syncQuizOosField();
}

function closeQuizOosPopup() {
  $('.desk_oos-popup-outer').removeClass('active');
  $('body').removeClass('desk_quiz-modal-open');
}

function syncQuizOosField() {
  $('.desk_oos-popup-outer .form_input-line').each(function () {
    var $line = $(this);

    $line.toggleClass('hasValue', $.trim($line.find('input').val() || '') !== '');
  });
}

function setQuizOosError($line, type) {
  var $msg = $line.find('.contact-error');
  var text;

  if (!type) {
    $line.removeClass('invalid');
    return;
  }

  text = type === 'email' ? $msg.attr('data-error-email') : $msg.attr('data-error-empty');

  if (text) $msg.text(text);

  $line.addClass('invalid');
}

function bindQuizOosPopup() {
  var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  $(document)
    .off('click.deskQuizOos keydown.deskQuizOos input.deskQuizOos focusin.deskQuizOos focusout.deskQuizOos')
    .on('click.deskQuizOos', '.desk_oos-popup-close', function () {
      closeQuizOosPopup();
    })
    .on('click.deskQuizOos', '.desk_oos-popup-outer', function (event) {
      if ($(event.target).is('.desk_oos-popup-outer')) closeQuizOosPopup();
    })
    .on('keydown.deskQuizOos', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) closeQuizOosPopup();
    })
    .on('focusin.deskQuizOos', '.desk_oos-popup-outer .form_input-line input', function () {
      $(this).closest('.form_input-line').addClass('active');
    })
    .on('focusout.deskQuizOos', '.desk_oos-popup-outer .form_input-line input', function () {
      $(this).closest('.form_input-line').removeClass('active');
      syncQuizOosField();
    })
    .on('input.deskQuizOos', '.desk_oos-popup-outer .form_input-line input', function () {
      var $line = $(this).closest('.form_input-line');
      var value = $.trim($(this).val());

      $line.toggleClass('hasValue', value !== '');

      if (value !== '' && pattern.test(value)) setQuizOosError($line, null);
    })
    .on('click.deskQuizOos', '.pdp_oos-submit', function () {
      var $popup = $(this).closest('.desk_oos-popup-outer');
      var $line = $popup.find('.form_input-line');
      var email = $.trim($line.find('input[type="email"]').val() || '');

      if (!email) return setQuizOosError($line, 'empty');
      if (!pattern.test(email)) return setQuizOosError($line, 'email');

      setQuizOosError($line, null);

      if (window.notificationSubmit) window.notificationSubmit(email, $popup.attr('data-id'));
    });
}

function getQuizOfferQuantity($offer) {
  var step = $.trim($offer.attr('data-quiz-quantity-step') || '');
  var quantity;

  if (!step) return 1;

  quantity = parseInt(resolveQuizRuleValue($offer.attr('data-quiz-quantity-rules'), getQuizAnswers(), step), 10);

  return quantity > 0 ? quantity : 1;
}

function getQuizVolumeDiscount($offer) {
  var quantity = getQuizOfferQuantity($offer);
  var lines = ($offer.attr('data-quiz-volume-rules') || '').split(';');
  var best = 0;
  var parts;
  var from;
  var percent;
  var i;

  for (i = 0; i < lines.length; i++) {
    parts = lines[i].split('=');

    if (parts.length !== 2) continue;

    from = parseInt($.trim(parts[0]), 10);
    percent = parseFloat($.trim(parts[1]));

    if (from > 0 && quantity >= from && percent > best) best = percent;
  }

  return best;
}

function applyQuizOfferPrice($card) {
  var match = findQuizOfferVariant($card);
  var $offer = $card.closest('.desk_quiz--offer');
  var discount = getQuizVolumeDiscount($offer);
  var priced = match;
  var $was;
  var $rrp;

  if (!match || !match.price) return;

  if (discount) priced = quizVolumePrices(match, discount, $offer.attr('data-quiz-money-sample'));

  $card.find('.desk_quiz-offer__price-now').text(priced.price);

  $was = $card.find('.desk_quiz-offer__price-was');
  $was.text(priced.was || '').prop('hidden', !priced.was);

  $rrp = $card.find('.desk_quiz-offer__price-rrp');
  $rrp.text(priced.rrp || '').prop('hidden', !priced.rrp);

  syncQuizPriceNote($card, match);
}

function syncQuizPriceNote($card, match) {
  var $note = $card.find('.desk_quiz-offer__price-note');
  var sample = $card.closest('.desk_quiz--offer').attr('data-quiz-money-sample');

  if (!$note.length || !match.wasCents || match.wasCents <= match.cents) return;

  $note.text($note.attr('data-quiz-price-note').replace('{amount}', formatQuizMoney(match.wasCents - match.cents, sample)));
}

function quizVolumePrices(match, discount, sample) {
  var cents = Math.round(match.cents * (1 - discount / 100));
  var wasCents = Math.max(match.wasCents || 0, match.cents);
  var rrpCents = match.rrpCents || 0;
  var fullCents = Math.max(rrpCents, wasCents);

  return {
    id: match.id,
    src: match.src,
    cents: cents,
    wasCents: wasCents,
    rrpCents: rrpCents,
    price: formatQuizMoney(cents, sample),
    was: formatQuizMoney(wasCents, sample),
    rrp: rrpCents > wasCents ? formatQuizMoney(rrpCents, sample) : '',
    badge: quizDiscountBadge(cents, fullCents, sample)
  };
}

function syncQuizOfferTotal() {
  var $button = $('.desk_quiz-offer__footer').find('[data-quiz-offer-add]');
  var $offer = $('.desk_quiz--offer');
  var label = $offer.attr('data-quiz-add-all-label') || '';
  var total = 0;
  var priced = true;

  if (!$button.length || label.indexOf('{price}') === -1) return;

  var discount = getQuizVolumeDiscount($offer);

  $('.desk_quiz-offer__card').each(function () {
    var match = findQuizOfferVariant($(this));

    if (!match || typeof match.cents !== 'number') priced = false;
    else total += discount ? Math.round(match.cents * (1 - discount / 100)) : match.cents;
  });

  if (!priced) return;

  $button
    .find('.desk_quiz-offer__add-label')
    .text(label.replace('{price}', formatQuizMoney(total, $offer.attr('data-quiz-money-sample'))));
}

function formatQuizMoney(cents, sample) {
  var parts = quizMoneyParts(sample);
  var amount = cents / 100;
  var text;

  if (window.deskRoundPrices) amount = Math.ceil(amount);

  if (Math.round(amount * 100) % 100 === 0 || !parts.dec) text = String(Math.round(amount));
  else text = amount.toFixed(2).replace('.', parts.dec);

  return parts.prefix + groupQuizThousands(text, parts) + parts.suffix;
}

function quizMoneyParts(sample) {
  var text = String(sample == null ? '' : sample);
  var prefix = (text.match(/^[^\d]*/) || [''])[0];
  var suffix = (text.match(/[^\d]*$/) || [''])[0];
  var digits = text.slice(prefix.length, text.length - suffix.length);

  return {
    prefix: prefix,
    suffix: suffix,
    dec: (digits.match(/([.,\s])\d{2}$/) || [])[1] || '',
    group: (digits.match(/^\d{1,3}([.,\s])\d{3}/) || [])[1] || ''
  };
}

function groupQuizThousands(text, parts) {
  var halves = parts.dec ? text.split(parts.dec) : [text];

  if (!parts.group) return text;

  halves[0] = halves[0].replace(/\B(?=(\d{3})+(?!\d))/g, parts.group);

  return halves.join(parts.dec);
}

function findQuizOfferVariant($card) {
  return quizVariantForColour($card, $card.find('.desk_quiz-offer__swatch.selected').first().attr('data-quiz-swatch-value'));
}

function quizVariantForColour($card, colour) {
  var variants = readQuizOfferVariants($card);
  var size;
  var match;

  if (!variants || !colour) return null;

  size = getQuizOfferSize($card);
  match = variants[size ? colour + '-' + size : colour];

  if (!match) match = variants[colour];

  // that colour is not made in that size — take any size of the same colour
  if (!match) match = findQuizVariantByColour(variants, colour);

  return match || null;
}

// Liquid stops at 250 variants. HomePro has 360, so the colours a shopper can
// pick are not guaranteed to be in the rendered map — the same reason the PDP
// pulls its variants over the Storefront API
// (snippets/desk_config_fetchAllVariants.liquid). This asks only when a swatch
// is actually unresolved, so the usual page costs no request at all.
function loadQuizOfferVariants() {
  var $offer = $('.desk_quiz--offer');
  var domain = $offer.attr('data-quiz-shop-domain');
  var token = $offer.attr('data-quiz-storefront-token');

  if (!domain || !token) return;

  $('.desk_quiz-offer__card').each(function () {
    var $card = $(this);
    var handle = $card.attr('data-quiz-offer-handle');

    if (!handle || !quizCardMissesAColour($card)) return;

    fetchQuizProductVariants(domain, token, $offer.attr('data-quiz-locale'), $offer.attr('data-quiz-country'), handle)
      .then(function (variants) {
        mergeQuizOfferVariants($card, variants);
        orderQuizSwatches();
        dropQuizUnavailableSwatches($card);
        markQuizSoldOutSwatches($card);
      })
      .catch(function () {
        // the rendered map still covers most colours; a missing one stays put
      });
  });
}

function quizCardMissesAColour($card) {
  var variants = readQuizOfferVariants($card);
  var missing = false;

  if (!variants) return false;

  $card.find('.desk_quiz-offer__swatch').each(function () {
    if (!quizVariantForColour($card, $(this).attr('data-quiz-swatch-value'))) missing = true;
  });

  return missing;
}

// Paged exactly like the PDP's fetcher, 250 at a time rather than 100.
function fetchQuizProductVariants(domain, token, locale, country, handle) {
  var collected = [];

  function page(cursor) {
    var query = 'query($language: LanguageCode, $country: CountryCode) @inContext(language: $language, country: $country) {' +
      ' productByHandle(handle: "' + handle + '") {' +
      '  variants(first: 250' + (cursor ? ', after: "' + cursor + '"' : '') + ') {' +
      '   pageInfo { hasNextPage endCursor }' +
      '   edges { node {' +
      '    id title availableForSale' +
      '    price { amount } compareAtPrice { amount }' +
      '    image { url(transform: { maxWidth: 950 }) }' +
      '    variantImage: metafield(namespace: "custom", key: "main_variant_image") { reference { ... on MediaImage { image { url(transform: { maxWidth: 950 }) } } } }' +
      '    variantImageFallback: metafield(namespace: "main", key: "variant_image") { reference { ... on MediaImage { image { url(transform: { maxWidth: 950 }) } } } }' +
      '   } }' +
      '  }' +
      ' }' +
      '}';

    return fetch('https://' + domain + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query, variables: { language: locale || 'EN', country: country || undefined } })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        var product = json && json.data && json.data.productByHandle;
        var info;

        if (!product) return collected;

        collected = collected.concat(
          product.variants.edges.map(function (edge) {
            return edge.node;
          })
        );
        info = product.variants.pageInfo;

        return info.hasNextPage ? page(info.endCursor) : collected;
      });
  }

  return page(null);
}

// Only fills gaps: where Liquid rendered an entry it stays, so the prices keep
// the exact formatting desk_money produced.
function mergeQuizOfferVariants($card, variants) {
  var existing = readQuizOfferVariants($card) || {};
  var bundle = $card.attr('data-quiz-bundle-discount') === 'true';
  var sample = $('.desk_quiz--offer').attr('data-quiz-money-sample');

  variants.forEach(function (variant) {
    var key = handleizeQuizValue(variant.title);
    var cents = quizAmountToCents(variant.price && variant.price.amount);
    var wasCents = quizAmountToCents(variant.compareAtPrice && variant.compareAtPrice.amount);
    var rrpCents = 0;
    var fullCents;

    if (!key || existing[key] || !cents) return;

    // the same 5% bundle rule the rendered card applies
    if (bundle) {
      if (wasCents > cents) rrpCents = wasCents;
      wasCents = cents;
      cents = Math.round(cents * 0.95);
    }

    fullCents = Math.max(rrpCents, wasCents);

    existing[key] = {
      id: String(variant.id).replace('gid://shopify/ProductVariant/', ''),
      src: quizVariantImage(variant),
      cents: cents,
      wasCents: wasCents,
      rrpCents: rrpCents,
      price: formatQuizMoney(cents, sample),
      was: wasCents > cents ? formatQuizMoney(wasCents, sample) : '',
      rrp: rrpCents > wasCents ? formatQuizMoney(rrpCents, sample) : '',
      badge: fullCents > cents ? quizDiscountBadge(cents, fullCents, sample) : '',
      available: variant.availableForSale !== false,
      size: quizVariantSize(variant.title)
    };
  });

  $card.find('.desk_quiz-offer__variants').text(JSON.stringify(existing));
}

function quizVariantImage(variant) {
  var meta = variant.variantImage || variant.variantImageFallback;
  var reference = meta && meta.reference && meta.reference.image;

  if (reference && reference.url) return reference.url;

  return (variant.image && variant.image.url) || '';
}

function quizAmountToCents(amount) {
  var value = parseFloat(amount);

  return isNaN(value) ? 0 : Math.round(value * 100);
}

function quizDiscountBadge(cents, wasCents, sample) {
  var percent = Math.round(((wasCents - cents) / wasCents) * 100);

  if (!window.deskDiscountBadge) return '-' + percent + '%';

  return window.deskDiscountBadge(percent, formatQuizMoney(cents, sample), formatQuizMoney(wasCents, sample));
}

// Shopify's handleize, as the PDP reproduces it — the comments there explain
// every replacement, and the keys have to match the ones Liquid rendered.
function handleizeQuizValue(value) {
  return String(value == null ? '' : value)
    .replace(/ß/g, 'ss')
    .replace(/æ/gi, 'ae')
    .replace(/ø/gi, 'o')
    .replace(/œ/gi, 'oe')
    .replace(/ł/gi, 'l')
    .replace(/đ/gi, 'd')
    .replace(/ð/gi, 'd')
    .replace(/þ/gi, 'th')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// A colour the product is not made in should not be offered. Only ever called
// once the full variant list is in, so this cannot hide a real colour.
function dropQuizUnavailableSwatches($card) {
  var $row = $card.find('[data-quiz-swatches]');
  var removed = 0;

  if (!readQuizOfferVariants($card)) return;

  $row.find('.desk_quiz-offer__swatch').each(function () {
    var $swatch = $(this);

    if (quizVariantForColour($card, $swatch.attr('data-quiz-swatch-value'))) return;

    $swatch.remove();
    removed++;
  });

  if (!removed) return;

  syncQuizSwatchMore($row);

  // the removed one may have been the selected colour
  if (!$row.find('.desk_quiz-offer__swatch.selected').length) {
    $row.find('.desk_quiz-offer__swatch').first().addClass('selected');
    setQuizSwatchLabel($row, $row.find('.desk_quiz-offer__swatch.selected').first());
  }

  refreshQuizOfferCard($card);
}

// CSS shows five; the "+N" beside them has to agree with what is left.
function syncQuizSwatchMore($row) {
  var rest = $row.find('.desk_quiz-offer__swatch').length - 5;
  var $more = $row.find('.desk_quiz-offer__swatch-more');

  if (!$more.length) return;

  $more.text('+' + rest).prop('hidden', rest < 1);
}

// A colour change should look instant, and it only does if the picture is
// already in the cache. The swatches on screen are warmed while the page is
// idle; the ones behind "+N" warm on hover or first touch.
function preloadQuizOfferImages() {
  var $rows = $('[data-quiz-swatches]');

  if (!$rows.length) return;

  function warmVisible() {
    $rows.each(function () {
      // CSS shows five per row; the rest wait until someone reaches for them
      $(this).find('.desk_quiz-offer__swatch').slice(0, 5).each(preloadQuizSwatchImage);
    });
  }

  if (window.requestIdleCallback) {
    window.requestIdleCallback(warmVisible);
    return;
  }

  setTimeout(warmVisible, 400);
}

function preloadQuizSwatchImage() {
  var $swatch = $(this);
  var match;

  if ($swatch.data('deskQuizWarmed')) return;

  $swatch.data('deskQuizWarmed', true);
  match = quizVariantForColour($swatch.closest('.desk_quiz-offer__card'), $swatch.attr('data-quiz-swatch-value'));

  if (match && match.src) new Image().src = match.src;
}

function readQuizOfferVariants($card) {
  var raw = $card.find('.desk_quiz-offer__variants').text();

  try {
    return JSON.parse(raw) || null;
  } catch (e) {
    return null;
  }
}

function findQuizVariantByColour(variants, colour) {
  var key;

  for (key in variants) {
    if (variants.hasOwnProperty(key) && key.indexOf(colour + '-') === 0) return variants[key];
  }

  return null;
}

// "over-180 = 180x80-cm" lines on the section, read against the size step's answer
function getQuizOfferSize($card) {
  var $offer = $card.closest('.desk_quiz--offer');

  return resolveQuizRuleValue(
    $offer.attr('data-quiz-size-rules'),
    getQuizAnswers(),
    $.trim($offer.attr('data-quiz-size-step') || '')
  );
}

// Answers to a value, first match wins. A line is "conditions = value"; several
// conditions joined by + all have to hold. A condition written "6: black" is
// read by the offer rule engine, so it can name any step and match multi-select
// answers; a bare one means "the default step's answer is this", or, with no
// default step, "some answer anywhere is this".
function resolveQuizRuleValue(rules, answers, defaultStep) {
  var lines = (rules || '').split(';');
  var parts;
  var conditions;
  var matched;
  var i;
  var j;

  for (i = 0; i < lines.length; i++) {
    parts = lines[i].split('=');

    if (parts.length !== 2) continue;

    conditions = parts[0].split('+');
    matched = true;

    for (j = 0; j < conditions.length; j++) {
      if (!quizConditionMatches($.trim(conditions[j]), answers, defaultStep)) matched = false;
    }

    if (matched) return $.trim(parts[1]);
  }

  return '';
}

function quizConditionMatches(condition, answers, defaultStep) {
  if (!condition) return false;
  if (condition.indexOf(':') > -1) return quizOfferRuleMatches(condition, answers);
  if (defaultStep) return quizOfferRuleMatches(defaultStep + ': ' + condition, answers);

  return quizAnswerUsed(condition, answers);
}

function quizSwatchChosen($swatch, answers) {
  var value = $swatch.attr('data-quiz-swatch-value');

  return !!value && quizAnswerUsed(value, answers);
}

// Is this value any of the answers, whichever step it came from? Loose on
// purpose: the colour question is a different step in every flow.
function quizAnswerUsed(value, answers) {
  var key;

  for (key in answers) {
    if (!answers.hasOwnProperty(key) || key.indexOf('step-') !== 0) continue;
    if (!$.isArray(answers[key]) && String(answers[key]) === value) return true;
  }

  return false;
}

function setQuizSwatchLabel($row, $chosen) {
  var label = $chosen.attr('data-quiz-swatch-label');

  if (label) $row.closest('.desk_quiz-offer__options').find('.desk_quiz-offer__options-value').text(label);
}

// why did I get this offer? run deskQuizOfferStatus() in the console.
// Recorded while choosing, because the losing sections are gone by the end.
function recordQuizOfferChoice($offers, answers, chosenKey) {
  var offers = [];

  $offers.each(function () {
    var $offer = $(this);

    offers.push({
      key: $offer.attr('data-quiz-offer-key') || '(none)',
      flow: $offer.attr('data-quiz-offer-flow') || '(any)',
      fallback: $offer.attr('data-quiz-offer-fallback') === 'true',
      matches: quizOfferMatches($offer, answers)
    });
  });

  window.deskQuizOfferStatus = function () {
    return { shown: chosenKey, flow: answers['step-flow'] || '(none)', answers: answers, offers: offers };
  };
}

function splitQuizValues(value) {
  return (value || '')
    .split(',')
    .map(function (item) {
      return $.trim(item);
    })
    .filter(function (item) {
      return item !== '';
    });
}

function isMultiSelectQuiz() {
  return $('.desk_quiz').attr('data-quiz-multi-select') === 'true';
}

function getQuizStep() {
  return $('.desk_quiz').attr('data-quiz-step');
}

// Where this screen's answer is stored. Detour screens (4a) share a step number
// with their parent for the progress ring, so they need their own key or they
// overwrite the answer the parent saved.
function getQuizAnswerKey() {
  return $('.desk_quiz').attr('data-quiz-key') || getQuizStep();
}

function getSelectedAnswers() {
  return $('.desk_quiz-option.selected, .desk_quiz-card.selected')
    .map(function () {
      return $(this).attr('data-quiz-answer');
    })
    .get();
}

function getQuizQuestionTitle() {
  return $('.desk_quiz').attr('data-quiz-question') || '';
}

// the visible answer text, without the grey note
function getQuizOptionLabel($option) {
  var $label = $option.find('.desk_quiz-option__label, .desk_quiz-card__title').first();

  if (!$label.length) return $option.attr('data-quiz-answer') || '';

  return $.trim($label.clone().children('.desk_quiz-option__note').remove().end().text());
}

function getSelectedLabels() {
  return $('.desk_quiz-option.selected, .desk_quiz-card.selected')
    .map(function () {
      return getQuizOptionLabel($(this));
    })
    .get();
}

function restoreQuizSelection() {
  var $options = $('.desk_quiz-option, .desk_quiz-card');

  restoreQuizSelects();

  if (!isMultiSelectQuiz()) {
    $options.removeClass('selected');
    return;
  }

  var saved = getQuizAnswers()['step-' + getQuizAnswerKey()] || [];

  $options.each(function () {
    var $option = $(this);
    var selected = $.inArray($option.attr('data-quiz-answer'), saved) > -1;

    $option.toggleClass('selected', selected).attr('aria-pressed', selected);
  });

  syncQuizContinue();
}

function syncQuizContinue() {
  var empty = isMultiSelectQuiz() && !$('.desk_quiz-option.selected, .desk_quiz-card.selected').length;

  $('.desk_quiz__continue').toggleClass('empty', empty).attr('aria-disabled', empty);
}

function bindQuizOptions() {
  $(document)
    .off('click.deskQuiz')
    .on('click.deskQuiz', '.desk_quiz-option, .desk_quiz-card', function () {
      var $option = $(this);
      var step = getQuizStep();
      var key = getQuizAnswerKey();

      if (isMultiSelectQuiz()) {
        var selected = !$option.hasClass('selected');

        $option.toggleClass('selected', selected).attr('aria-pressed', selected);
        saveQuizAnswer(key, getSelectedAnswers());
        saveQuizQuestion(getQuizQuestionTitle(), getSelectedLabels().join(', '));
        syncQuizContinue();
        return;
      }

      var answer = $option.attr('data-quiz-answer');
      var variantId = $option.attr('data-quiz-variant-id');
      var setFlow = $option.attr('data-quiz-set-flow');

      if (setFlow) setQuizFlow(setFlow);

      $option.addClass('selected');
      saveQuizAnswer(key, answer);
      saveQuizQuestion(getQuizQuestionTitle(), getQuizOptionLabel($option));

      if (variantId) saveQuizAnswer('variant-id', variantId);

      trackQuizAnswer(step, answer);
      showQuizOptionLoader($option);
    })
    .off('click.deskQuizContinue')
    .on('click.deskQuizContinue', '.desk_quiz__continue', function (event) {
      if ($(this).hasClass('empty')) {
        event.preventDefault();
        return;
      }

      if ($(this).is('button')) return;

      trackQuizAnswer(getQuizStep(), getSelectedAnswers());
      showQuizOptionLoader($(this));
    });
}

// arrow turns into a spinner while the next page loads
function showQuizOptionLoader($option) {
  if (!$option.is('a') || !$option.attr('href')) return;

  $('.desk_quiz-option, .desk_quiz-card, .desk_quiz__continue').addClass('disabled');
  $option.addClass('loading');
}

function clearQuizOptionLoaders() {
  $('.desk_quiz-option, .desk_quiz-card, .desk_quiz__continue').removeClass('loading disabled');
}

function bindQuizSelects() {
  $(document)
    .off('submit.deskQuizSelects change.deskQuizSelects')
    .on('submit.deskQuizSelects', '.desk_quiz-selects', function (event) {
      event.preventDefault();

      var $form = $(this);
      var valid = true;

      $form.find('[data-quiz-select]').each(function () {
        var filled = $.trim($(this).val()) !== '';

        $(this).closest('[data-quiz-dropdown]').toggleClass('error', !filled);

        if (!filled) valid = false;
      });

      if (!valid) return;

      $form.find('[data-quiz-select]').each(function () {
        var $select = $(this);
        var label = $.trim($select.closest('[data-quiz-dropdown]').attr('data-quiz-label') || '');

        saveQuizAnswer($select.attr('name'), $select.val());
        saveQuizQuestion(label || getQuizQuestionTitle(), $.trim($select.find('option:selected').text()));
      });

      trackQuizAnswer(getQuizStep(), getQuizSelectValues($form));

      var nextUrl = $form.attr('data-quiz-next');

      if (!nextUrl) return;

      $('.desk_quiz-option, .desk_quiz-card, .desk_quiz__continue').addClass('disabled');
      $form.find('.desk_quiz__continue').addClass('loading');
      window.location.href = nextUrl;
    })
    .on('change.deskQuizSelects', '.desk_quiz-selects [data-quiz-select]', function () {
      $(this).closest('[data-quiz-dropdown]').removeClass('error');
    });
}

function bindQuizDropdowns() {
  $(document)
    .off('click.deskQuizDropdown keydown.deskQuizDropdown')
    .on('click.deskQuizDropdown', '[data-quiz-dropdown-field]', function (event) {
      var $dropdown = $(this).closest('[data-quiz-dropdown]');

      event.preventDefault();

      if ($dropdown.hasClass('is-open')) {
        closeQuizDropdowns();
        return;
      }

      closeQuizDropdowns();
      $dropdown.addClass('is-open');
      $(this).attr('aria-expanded', 'true');
    })
    .on('click.deskQuizDropdown', '.desk_quiz-dropdown__option', function () {
      var $option = $(this);
      var $dropdown = $option.closest('[data-quiz-dropdown]');

      setQuizDropdownValue($dropdown, $option);
      closeQuizDropdowns();
      $dropdown.find('[data-quiz-select]').val(String($option.attr('data-value'))).trigger('change');
    })
    .on('click.deskQuizDropdown', function (event) {
      if (!$(event.target).closest('[data-quiz-dropdown]').length) closeQuizDropdowns();
    })
    .on('keydown.deskQuizDropdown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) closeQuizDropdowns();
    });
}

function closeQuizDropdowns() {
  $('[data-quiz-dropdown].is-open').removeClass('is-open').find('[data-quiz-dropdown-field]').attr('aria-expanded', 'false');
}

function setQuizDropdownValue($dropdown, $option) {
  $dropdown.find('.desk_quiz-dropdown__option').removeClass('is-selected').attr('aria-selected', 'false');
  $option.addClass('is-selected').attr('aria-selected', 'true');
  $dropdown.find('[data-quiz-dropdown-value]').text($.trim($option.text()));
  $dropdown.addClass('has-value');
}

function syncQuizDropdowns() {
  $('[data-quiz-dropdown]').each(function () {
    var $dropdown = $(this);
    var value = $dropdown.find('[data-quiz-select]').val();
    var $option;

    if (!value) return;

    $option = $dropdown.find('.desk_quiz-dropdown__option').filter(function () {
      return String($(this).attr('data-value')) === String(value);
    }).first();

    if ($option.length) setQuizDropdownValue($dropdown, $option);
  });
}

function getQuizSelectValues($form) {
  return $form
    .find('[data-quiz-select]')
    .map(function () {
      return $(this).val();
    })
    .get();
}

function restoreQuizSelects() {
  var answers = getQuizAnswers();

  $('.desk_quiz-selects [data-quiz-select]').each(function () {
    var saved = answers['step-' + $(this).attr('name')];

    if (saved) $(this).val(saved);
  });

  syncQuizDropdowns();
}

// What a Klaviyo popup does when someone signs up, and the reason it never
// shows twice.
function identifyQuizProfile(email, properties) {
  var payload = properties || {};

  if (!window.klaviyo || !window.klaviyo.push) return;

  if (email) payload.$email = email;
  if (!payload.$email && !properties) return;

  try {
    window.klaviyo.push(['identify', payload]);
  } catch (e) {
    // the onsite script is the app's, not ours; never let it break the quiz
  }
}

// Klaviyo's own answer to "do we know this browser", which also covers someone
// identified by clicking through one of their emails. It resolves late, so the
// answer is cached and read on a later screen rather than awaited here.
function resolveQuizIdentified() {
  if (!window.klaviyo || !window.klaviyo.isIdentified) return;

  try {
    window.klaviyo.isIdentified().then(function (identified) {
      setQuizFlag(DESK_QUIZ_IDENTIFIED_KEY, identified ? '1' : '0');
    });
  } catch (e) {
    // no promise, no answer: the other sources cover it
  }
}

function quizProfileIdentified() {
  return getQuizFlag(DESK_QUIZ_IDENTIFIED_KEY) === '1';
}

// Asking again for an address we already have is friction for no gain, so the
// screen is skipped — but the profile still gets this run's answers, which is
// the only reason the step exists once the address is known.
function skipQuizEmailStep() {
  var $form = getQuizEmailStepForm();
  var email;
  var nextUrl;

  if (!$form.length || $form.attr('data-quiz-skip-known') !== 'true') return revealQuizEmail();

  // the theme editor has to be able to see and edit this section
  if (window.Shopify && window.Shopify.designMode) return revealQuizEmail();

  email = getKnownQuizEmail();
  nextUrl = $form.attr('data-quiz-next');

  // Only ever once. Coming back to this screen from the results means the
  // customer asked for it, and skipping again would trap them there.
  if (!nextUrl || quizEmailSkipped() || !(email || quizProfileIdentified())) {
    prefillQuizEmail(email);
    return revealQuizEmail();
  }

  // this screen did load, so the question before it is the one they came from
  rememberQuizSkipOrigin(quizSameOriginPath(document.referrer));
  startQuizEmailSkip(email);
  // replace, not push: the screen they never saw should not be in their history
  goToQuizNext(null, nextUrl, true);
}

// Nothing here waits on Klaviyo — the request is handed to the results page,
// which is loading anyway and by then also knows which product won.
function startQuizEmailSkip(email) {
  markQuizEmailSkipped();
  setQuizFlag(DESK_QUIZ_EMAIL_VISIBLE_KEY, '0');

  if (email) {
    saveQuizAnswer('email', email);
    setQuizFlag(DESK_QUIZ_PENDING_KEY, email);
    return;
  }

  // Klaviyo knows this browser but will not tell us the address. The answers
  // can still reach the profile through the identity it already holds.
  setQuizFlag(DESK_QUIZ_PENDING_KEY, '1');
}

function flushQuizPendingSubscribe() {
  var pending = getQuizFlag(DESK_QUIZ_PENDING_KEY);
  var emailVisible = getQuizFlag(DESK_QUIZ_EMAIL_VISIBLE_KEY) === '1';

  if (!pending || !$('.desk_quiz--offer').length) return;

  setQuizFlag(DESK_QUIZ_PENDING_KEY, '');

  if (pending === '1') {
    sendQuizEvent('', emailVisible);
    return;
  }

  sendQuizEvent(pending, emailVisible);
  identifyQuizProfile(pending);
}

function prefillQuizEmail(email) {
  var input = getQuizEmailStepForm().find('.desk-field input')[0];

  if (email && input && !input.value) input.value = email;
}

function quizEmailSkipped() {
  return getQuizFlag(DESK_QUIZ_EMAIL_SKIPPED_KEY) === '1';
}

function markQuizEmailSkipped() {
  setQuizFlag(DESK_QUIZ_EMAIL_SKIPPED_KEY, '1');
}

function runQuizLoader() {
  var $loader = $('.desk_quiz-loader');
  var signature;
  var duration;

  if (!$loader.length) return;

  if ((window.Shopify && window.Shopify.designMode) || $loader.hasClass('done')) {
    hideQuizLoader($loader, true);
    return;
  }

  signature = getQuizLoaderSignature();

  if (getQuizFlag(DESK_QUIZ_LOADER_KEY) === signature) {
    hideQuizLoader($loader, true);
    return;
  }

  setQuizFlag(DESK_QUIZ_LOADER_KEY, signature);
  duration = parseInt($loader.attr('data-quiz-loader-duration'), 10) || 1200;

  setTimeout(function () {
    hideQuizLoader($loader, false);
  }, duration);
}

function placeQuizLoader() {
  var $loader = $('.desk_quiz-loader');
  var $products = $('.desk_quiz--offer').not('.filtering').first().find('.desk_quiz-offer__products');

  if (!$loader.length || $loader.hasClass('done') || !$products.length) return;

  $products.append($loader);
}

function hideQuizLoader($loader, instant) {
  $loader.toggleClass('instant', instant).addClass('done').attr('aria-hidden', 'true');
  $('html').removeClass('desk_quiz-loading');
}

function getQuizLoaderSignature() {
  var answers = getQuizAnswers();
  var kept = {};

  Object.keys(answers).forEach(function (key) {
    if (key === 'step-offer' || key === 'step-email' || key === 'step-variant-id') return;

    kept[key] = answers[key];
  });

  return window.location.pathname + '|' + JSON.stringify(kept);
}

function initQuizInlineEmail() {
  var $section = $('.desk_quiz--email-inline');
  var email;
  var signature;

  if (!$section.length) return;
  if (window.Shopify && window.Shopify.designMode) return;

  email = getKnownQuizEmail();

  if (!email && !quizProfileIdentified()) return;

  $section.addClass('known');
  trackQuizEmail('known');

  if (getQuizFlag(DESK_QUIZ_PENDING_KEY)) return;

  signature = getQuizInlineSignature(email);

  if (getQuizFlag(DESK_QUIZ_INLINE_SENT_KEY) === signature) return;

  setQuizFlag(DESK_QUIZ_INLINE_SENT_KEY, signature);

  if (email) {
    sendQuizEvent(email);
    identifyQuizProfile(email);
    return;
  }

  sendQuizEvent('');
}

function getQuizInlineSignature(email) {
  return (getQuizAnswers()['step-offer'] || '') + '|' + (email || '');
}

function showQuizEmailSuccess($form) {
  $form.addClass('sent');
  $form.find('.desk_quiz-email__success').prop('hidden', false);
}

function trackQuizEmail(value) {
  var anon = getQuizTrackMode() === 'anon';

  if (!getQuizScreen() || !quizTrackingAllowed()) return;
  if (!anon && quizEventSeen('answer:email')) return;

  if (!anon) markQuizEvent('answer:email', 1);
  beaconQuizEvents([buildQuizEvent('answer', 'email', value)]);
}

function getQuizFlag(key) {
  try {
    return window.sessionStorage.getItem(key) || '';
  } catch (e) {
    return '';
  }
}

function setQuizFlag(key, value) {
  try {
    if (value === '') {
      window.sessionStorage.removeItem(key);
      return;
    }

    window.sessionStorage.setItem(key, value);
  } catch (e) {
    // storage is blocked; every caller degrades to "we do not know"
  }
}

function revealQuizEmail() {
  $('.desk_quiz--email').removeClass('filtering');
}

function getQuizEmailStepForm() {
  return $('.desk_quiz-email').not('[data-quiz-inline="true"]');
}

function rememberQuizSkipOrigin(path) {
  if (path) setQuizFlag(DESK_QUIZ_SKIP_FROM_KEY, path);
}

function quizSameOriginPath(url) {
  if (!url || String(url).indexOf(window.location.origin) !== 0) return '';

  return quizPathOf(url);
}

// Going back from the results should land on the question they last answered.
// The back link points at the email step, which they never saw — following it
// would open a screen that only exists to be skipped.
function applyQuizSkippedBackLink() {
  var routes = readQuizEmailRoutes();
  var $quiz = $('.desk_quiz');
  var origin = getQuizFlag(DESK_QUIZ_SKIP_FROM_KEY);

  if (!origin || !routes || !quizEmailSkipped()) return;
  if (quizPathOf($quiz.attr('data-quiz-prev')) !== routes.path) return;

  $quiz.attr('data-quiz-prev', origin);
}

// Where the results live is known only to the email step — its own next link and
// its flow routes. Cached here so the last question of a flow can send a
// returning customer straight there, instead of through a screen they would
// only be bounced out of.
function cacheQuizEmailRoutes() {
  var $form = getQuizEmailStepForm();
  var routes;

  if (!$form.length) return;

  routes = { path: window.location.pathname, urls: {}, saved: Date.now() };
  routes.urls[''] = $.trim($form.attr('data-quiz-next') || '');

  $('.desk_quiz-route').each(function () {
    var $route = $(this);

    routes.urls[$route.attr('data-quiz-flow')] = $.trim($route.attr('data-quiz-url') || '');
  });

  try {
    window.localStorage.setItem(DESK_QUIZ_EMAIL_ROUTES_KEY, JSON.stringify(routes));
  } catch (e) {
    // without this the screen still skips itself, just one page later
  }
}

function readQuizEmailRoutes() {
  var routes;

  try {
    routes = JSON.parse(window.localStorage.getItem(DESK_QUIZ_EMAIL_ROUTES_KEY) || 'null');
  } catch (e) {
    return null;
  }

  if (!routes || !routes.path || !routes.urls) return null;
  // a link this old is more likely to 404 than to help
  if (Date.now() - (routes.saved || 0) > 5184000000) return null;

  return routes;
}

// Rewrite the links that point at the email step, on the screen before it.
function applyQuizEmailSkipLinks() {
  var routes = readQuizEmailRoutes();
  var rerouted = false;
  var target;

  if (!routes || getQuizEmailStepForm().length) return;
  if (!getKnownQuizEmail() && !quizProfileIdentified()) return;

  target = routes.urls[getQuizFlow()] || routes.urls[''];

  if (!target || quizPathOf(target) === routes.path) return;

  $('.desk_quiz-option, .desk_quiz-card, .desk_quiz__continue').each(function () {
    var $link = $(this);

    if (!$link.is('a') || quizPathOf($link.attr('href')) !== routes.path) return;

    $link.attr('href', target);
    rerouted = true;
  });

  $('.desk_quiz-selects').each(function () {
    var $form = $(this);

    if (quizPathOf($form.attr('data-quiz-next')) !== routes.path) return;

    $form.attr('data-quiz-next', target);
    rerouted = true;
  });

  if (!rerouted) return;

  // Marks the skip as used, which the results page's back link depends on:
  // without it the return trip would be bounced straight forward again.
  rememberQuizSkipOrigin(window.location.pathname);
  startQuizEmailSkip(getKnownQuizEmail());
}

function quizPathOf(url) {
  var link;

  if (!url) return '';

  link = document.createElement('a');
  link.href = url;

  return link.pathname;
}

// This session first, then the logged-in customer, then Klaviyo's own identity
// cookie, and only last the copy we kept ourselves.
function getKnownQuizEmail() {
  var saved = getQuizAnswers()['step-email'];

  if (saved && !$.isArray(saved)) return String(saved);

  if (window.deskQuizKnownEmail) return window.deskQuizKnownEmail;

  saved = getQuizKlaviyoEmail();

  if (saved) return saved;

  try {
    return window.localStorage.getItem(DESK_QUIZ_EMAIL_KEY) || '';
  } catch (e) {
    return '';
  }
}

// Klaviyo keeps the profile it has identified in its own cookie. The shape is
// theirs and undocumented, so every step of this is best-effort.
function getQuizKlaviyoEmail() {
  var match = document.cookie.match(/__kla_id=([^;]+)/);
  var decoded;

  if (!match) return '';

  try {
    decoded = JSON.parse(window.atob(decodeURIComponent(match[1])));
  } catch (e) {
    return '';
  }

  return (decoded && decoded.$email) || '';
}

function rememberQuizEmail(email) {
  try {
    window.localStorage.setItem(DESK_QUIZ_EMAIL_KEY, email);
  } catch (e) {
    // private browsing; the session copy still covers this run
  }
}

function bindQuizEmail() {
  $(document)
    .off('submit.deskQuizEmail')
    .on('submit.deskQuizEmail', '.desk_quiz-email', function (event) {
      event.preventDefault();

      var $form = $(this);
      var input = $form.find('.desk-field input')[0];
      var $consent = $form.find('[data-quiz-consent]');
      var consent = $consent.find('.desk_quiz-consent__input')[0];

      if (input && !input.checkValidity()) {
        $form.find('.desk-field').addClass('error');
        input.focus();
        return;
      }

      if (consent && !consent.checked) {
        $consent.addClass('error').find('.desk_quiz-consent__msg').prop('hidden', false);
        consent.focus();
        return;
      }

      var email = $.trim($(input).val());

      saveQuizAnswer('email', email);
      rememberQuizEmail(email);
      identifyQuizProfile(email);

      if (consent && consent.checked) subscribeQuizNewsletter(email);

      if ($form.attr('data-quiz-inline') === 'true') {
        sendQuizEvent(email, true);
        setQuizFlag(DESK_QUIZ_INLINE_SENT_KEY, getQuizInlineSignature(email));
        trackQuizEmail('provided');
        showQuizEmailSuccess($form);
        return;
      }

      trackQuizAnswer('email', 'provided');
      // the result page subscribes, once it knows which offer won
      setQuizFlag(DESK_QUIZ_PENDING_KEY, email);
      setQuizFlag(DESK_QUIZ_EMAIL_VISIBLE_KEY, '1');
      goToQuizNext(null, $form.attr('data-quiz-next'));
    })
    .off('input.deskQuizEmail')
    .on('input.deskQuizEmail', '.desk_quiz-email .desk-field input', function () {
      $(this).closest('.desk-field').removeClass('error');
    })
    .off('change.deskQuizConsent')
    .on('change.deskQuizConsent', '.desk_quiz-email .desk_quiz-consent__input', function () {
      $(this)
        .closest('[data-quiz-consent]')
        .removeClass('error')
        .find('.desk_quiz-consent__msg')
        .prop('hidden', true);
    });
}

function subscribeQuizNewsletter(email) {
  var lists = window.deskKlaviyoLists;

  if (!window.deskKlaviyoSubscribe || !lists || !lists.newsletter) return;

  window.deskKlaviyoSubscribe(lists.newsletter, email, '$source, $last_name', { $source: 'Quiz' }, true);
}

function bindQuizHelp() {
  $(document)
    .off('click.deskQuizHelp keydown.deskQuizHelp')
    .on('click.deskQuizHelp', '.desk_quiz-header__help', function (event) {
      if (!window.matchMedia('(max-width: 799px)').matches) return;

      event.preventDefault();
      toggleQuizHelp(true);
    })
    .on('click.deskQuizHelp', '.desk_quiz-help__close', function () {
      toggleQuizHelp(false);
    })
    .on('keydown.deskQuizHelp', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) toggleQuizHelp(false);
    });
}

function bindQuizModal() {
  $(document)
    .off('click.deskQuizModal keydown.deskQuizModal')
    .on('click.deskQuizModal', '.desk_quiz-header__logo', function (event) {
      if (openQuizModal($(this).attr('href'))) event.preventDefault();
    })
    .on('click.deskQuizModal', '.desk_quiz-back', function (event) {
      if (getQuizStep() !== '1') return;

      if (openQuizModal($(this).attr('href'))) event.preventDefault();
    })
    .on('click.deskQuizModal', '.desk_quiz-help__option--exit', function (event) {
      if (openQuizModal($(this).attr('href'))) event.preventDefault();
    })
    .on(
      'click.deskQuizModal',
      '.desk_quiz-modal__keep, .desk_quiz-modal__close, .desk_quiz-modal__overlay',
      function () {
        toggleQuizModal(false);
      }
    )
    .on('keydown.deskQuizModal', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) toggleQuizModal(false);
    });
}

function openQuizModal(url) {
  var $modal = $('.desk_quiz-modal');

  if (!$modal.length) return false;

  $modal.find('.desk_quiz-modal__exit').attr('href', url || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
  toggleQuizModal(true);

  return true;
}

function bindQuizBackTrap() {
  var $quiz = $('.desk_quiz');

  if (deskQuizBackTrapArmed) return;
  if (!$quiz.length || getQuizStep() !== '1') return;
  if ($quiz.attr('data-quiz-intercept-back') !== 'true') return;
  if (!$('.desk_quiz-modal').length) return;

  deskQuizBackTrapArmed = true;
  history.replaceState({ deskQuizStep: 0 }, '');
  history.pushState({ deskQuizStep: 1 }, '');

  $(window)
    .off('popstate.deskQuizTrap')
    .on('popstate.deskQuizTrap', function (event) {
      var state = event.originalEvent && event.originalEvent.state;

      if (!state || state.deskQuizStep !== 0) return;

      history.pushState({ deskQuizStep: 1 }, '');
      openQuizModal($quiz.attr('data-quiz-prev'));
    });
}

function toggleQuizModal(open) {
  $('.desk_quiz-modal').toggleClass('active', open).attr('aria-hidden', !open);
  $('body').toggleClass('desk_quiz-modal-open', open);
}

function toggleQuizHelp(open) {
  $('.desk_quiz-help').toggleClass('active', open).attr('aria-hidden', !open);
  $('body').toggleClass('desk_quiz-help-open', open);
}

// An event, not a list subscribe: a retake sends another one, so the flow runs
// again. No unique_id on purpose — that is what Klaviyo de-duplicates on.
function sendQuizEvent(email, emailVisible) {
  var companyId = window.deskKlaviyoAccount;
  var properties = getQuizEventProperties(emailVisible);

  if (!email) return trackQuizEventOnsite(properties);
  if (!companyId) return null;

  return fetch(DESK_QUIZ_KLAVIYO_URL + '?company_id=' + encodeURIComponent(companyId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/vnd.api+json',
      revision: DESK_QUIZ_KLAVIYO_REVISION
    },
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: properties,
          metric: { data: { type: 'metric', attributes: { name: DESK_QUIZ_EVENT_NAME } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    })
  });
}

// No address, but Klaviyo already knows this browser — its own script can put
// the event on the identity it holds.
function trackQuizEventOnsite(properties) {
  if (!window.klaviyo || !window.klaviyo.push) return null;

  try {
    window.klaviyo.push(['track', DESK_QUIZ_EVENT_NAME, properties]);
  } catch (e) {
    // the onsite script is the app's, not ours; never let it break the quiz
  }

  return null;
}

// leave only once Klaviyo has answered, but never hang on it
function goToQuizNext(request, nextUrl, replace) {
  if (!nextUrl) return;

  var left = false;

  function go() {
    if (left) return;

    left = true;

    if (replace) {
      window.location.replace(nextUrl);
      return;
    }

    window.location.href = nextUrl;
  }

  if (!request || !request.always) {
    go();
    return;
  }

  request.always(go);
  setTimeout(go, 1500);
}

// The question text and the answer label are already what we want to send, so
// they go out untouched — no slug, no truncation.
function getQuizEventProperties(emailVisible) {
  var properties = {};
  var answers = getQuizAnswers();
  var asked = getQuizQuestions();

  properties['Quiz - Email step visible'] = emailVisible === true;

  if (answers['step-flow']) properties['Quiz - Flow'] = answers['step-flow'];
  if (answers['step-offer']) properties['Quiz - Offer'] = answers['step-offer'];
  if (answers['step-variant-id']) properties['Quiz - Variant ID'] = answers['step-variant-id'];

  Object.keys(asked).forEach(function (question) {
    var key = $.trim(question);

    if (key) properties['Quiz - ' + key] = asked[question];
  });

  return properties;
}

function trackQuizPage() {
  var screen = getQuizScreen();
  var events;

  if (!screen || !quizTrackingAllowed()) return;

  if (screen === 'quiz-1' && quizRunFinished()) resetQuizTrackSession();

  if (getQuizTrackMode() === 'anon') {
    sendQuizEvents([buildQuizEvent('view', screen, '')]);
    return;
  }

  events = readQuizQueue();
  if (events.length) writeQuizQueue(null);

  if (!quizEventSeen('view:' + screen)) {
    markQuizEvent('view:' + screen);
    events.push(buildQuizEvent('view', screen, ''));
  }

  sendQuizEvents(events);
}

// a new run after reaching a result is a new journey
function quizRunFinished() {
  return Object.keys(getQuizSent()).some(function (key) {
    return key.indexOf('view:quiz-offer') === 0;
  });
}

function resetQuizTrackSession() {
  try {
    sessionStorage.removeItem(DESK_QUIZ_SESSION_KEY);
    sessionStorage.removeItem(DESK_QUIZ_SENT_KEY);
    sessionStorage.removeItem(DESK_QUIZ_QUEUE_KEY);
  } catch (e) {}
}

function trackQuizAnswer(step, answer) {
  var screen = getQuizScreen();
  var key = 'answer:' + screen;
  var value = cleanQuizValue(answer);

  if (!screen || !quizTrackingAllowed()) return;

  if (getQuizTrackMode() === 'session') {
    if (getQuizSent()[key] === value) return;
    markQuizEvent(key, value);
  }

  beaconQuizEvents([buildQuizEvent('answer', screen, value)]);
}

function trackQuizAddToCart() {
  var screen = getQuizScreen();
  var anon = getQuizTrackMode() === 'anon';

  if (!screen || !quizTrackingAllowed()) return;
  if (!anon && quizEventSeen('cart:' + screen)) return;

  if (!anon) markQuizEvent('cart:' + screen);
  beaconQuizEvents([buildQuizEvent('view', 'add_to_cart', '')]);
}

function trackQuizOptions() {
  var screen = getQuizScreen();
  var anon = getQuizTrackMode() === 'anon';

  if (!screen || !quizTrackingAllowed()) return;
  if (!anon && quizEventSeen('options:' + screen)) return;

  if (!anon) markQuizEvent('options:' + screen);
  beaconQuizEvents([buildQuizEvent('view', 'options', '')]);
}

function buildQuizEvent(type, screen, value) {
  var $quiz = $('.desk_quiz');
  var step = parseInt($quiz.attr('data-quiz-step'), 10) || 0;

  return {
    t: type,
    screen: screen,
    step: screen === 'add_to_cart' || screen === 'email' ? step + 1 : step,
    flow: getQuizFlow(),
    // sent on answers too, so a row still gets its question text when the view
    // was already recorded earlier in the session
    q: $quiz.attr('data-quiz-question') || $quiz.attr('data-quiz-section') || '',
    value: value
  };
}

// answer values only — an email address never reaches the endpoint
function cleanQuizValue(answer) {
  var value = $.isArray(answer) ? answer.join(', ') : String(answer == null ? '' : answer);

  if (value.indexOf('@') > -1) return 'provided';

  return value.slice(0, 80);
}

function buildQuizPayload(events) {
  var config = window.deskQuizTrack || {};
  var payload = { shop: config.shop || '', events: events };
  var session = getQuizTrackMode() === 'session' ? getQuizSessionId() : '';

  if (session) {
    payload.session = session;
  } else {
    payload.anon = 1;
  }

  return JSON.stringify(payload);
}

// text/plain keeps this a simple request, so there is no preflight per page
function sendQuizEvents(events) {
  var config = window.deskQuizTrack || {};

  if (!events.length || !config.url) return;

  try {
    fetch(config.url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      keepalive: true,
      body: buildQuizPayload(events)
    }).catch(function () {});
  } catch (e) {}
}

// survives the navigation the click is about to start
function beaconQuizEvents(events) {
  var config = window.deskQuizTrack || {};
  var body;

  if (!events.length || !config.url) return;

  body = buildQuizPayload(events);

  try {
    if (navigator.sendBeacon && navigator.sendBeacon(config.url, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
  } catch (e) {}

  sendQuizEvents(events);
}

function quizTrackingAllowed() {
  if (!(window.deskQuizTrack || {}).url) {
    window.deskQuizTrackBlocked = 'no endpoint set';
    return false;
  }

  window.deskQuizTrackBlocked = '';

  return true;
}

// no consent: counted anonymously, nothing stored for tracking
function getQuizTrackMode() {
  if (quizConsentState() === false) return 'anon';

  return getQuizSessionId() ? 'session' : 'anon';
}

// true / false / null when Shopify's privacy API is not on the page
function quizConsentState() {
  var privacy = window.Shopify && window.Shopify.customerPrivacy;

  // `shopify theme dev` has no consent banner to accept, so the gate would make
  // the funnel untestable. Keyed on the hostname, which no production domain can
  // ever be — there is no setting here to leave switched on by accident.
  if (quizIsLocalPreview()) return null;

  if (!privacy || !privacy.analyticsProcessingAllowed) return null;

  return privacy.analyticsProcessingAllowed() === true;
}

function quizIsLocalPreview() {
  var host = window.location.hostname;

  return host === '127.0.0.1' || host === 'localhost';
}

// why is nothing being sent? run deskQuizTrackStatus() in the console
function deskQuizTrackStatus() {
  var config = window.deskQuizTrack || {};
  var stored = '';

  try {
    stored = sessionStorage.getItem(DESK_QUIZ_SESSION_KEY) || '';
  } catch (e) {
    stored = '(storage blocked)';
  }

  return {
    url: config.url || '(not set — fill in the Quiz funnel endpoint setting)',
    screen: config.screen || '(not a quiz page)',
    consent: quizConsentState(),
    mode: getQuizTrackMode(),
    session: stored || '(none yet)',
    queued: readQuizQueue(),
    sent: Object.keys(getQuizSent())
  };
}

window.deskQuizTrackStatus = deskQuizTrackStatus;

function getQuizScreen() {
  return (window.deskQuizTrack || {}).screen || '';
}

// one id per tab, minted on the first quiz page, cleared with the answers
function getQuizSessionId() {
  var id;

  try {
    id = sessionStorage.getItem(DESK_QUIZ_SESSION_KEY);

    if (!id) {
      id = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem(DESK_QUIZ_SESSION_KEY, id);
    }
  } catch (e) {
    return '';
  }

  return id;
}

function quizEventSeen(key) {
  return getQuizSent()[key] === 1;
}

// views store 1, answers store the value sent, so a changed answer resends
function markQuizEvent(key, value) {
  var sent = getQuizSent();

  sent[key] = value === undefined ? 1 : value;

  try {
    sessionStorage.setItem(DESK_QUIZ_SENT_KEY, JSON.stringify(sent));
  } catch (e) {}
}

function getQuizSent() {
  try {
    return JSON.parse(sessionStorage.getItem(DESK_QUIZ_SENT_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function readQuizQueue() {
  try {
    return JSON.parse(sessionStorage.getItem(DESK_QUIZ_QUEUE_KEY)) || [];
  } catch (e) {
    return [];
  }
}

function writeQuizQueue(queue) {
  try {
    if (!queue) {
      sessionStorage.removeItem(DESK_QUIZ_QUEUE_KEY);
      return;
    }

    sessionStorage.setItem(DESK_QUIZ_QUEUE_KEY, JSON.stringify(queue));
  } catch (e) {}
}

// Switching branch drops the answers from the branch being left. Step numbers
// repeat across branches, so a leftover step-7 from a desk run would otherwise
// still be sitting there when the customer restarts as a chair.
function setQuizFlow(flow) {
  if (getQuizFlow() && getQuizFlow() !== flow) clearQuizStepAnswers();

  saveQuizAnswer('flow', flow);
}

function clearQuizStepAnswers() {
  var answers = getQuizAnswers();
  var kept = {};

  if (answers['step-email']) kept['step-email'] = answers['step-email'];

  try {
    sessionStorage.setItem(DESK_QUIZ_STORAGE_KEY, JSON.stringify(kept));
    sessionStorage.removeItem(DESK_QUIZ_QUESTIONS_KEY);
  } catch (e) {}
}

function saveQuizAnswer(step, answer) {
  var answers = getQuizAnswers();

  answers['step-' + step] = answer;

  try {
    sessionStorage.setItem(DESK_QUIZ_STORAGE_KEY, JSON.stringify(answers));
  } catch (e) {}
}

function getQuizAnswers() {
  try {
    return JSON.parse(sessionStorage.getItem(DESK_QUIZ_STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function clearQuizAnswers() {
  try {
    sessionStorage.removeItem(DESK_QUIZ_STORAGE_KEY);
    sessionStorage.removeItem(DESK_QUIZ_QUESTIONS_KEY);
    sessionStorage.removeItem(DESK_QUIZ_SESSION_KEY);
    sessionStorage.removeItem(DESK_QUIZ_QUEUE_KEY);
    sessionStorage.removeItem(DESK_QUIZ_SENT_KEY);
    // the address itself is deliberately kept: they subscribed, and a retake
    // should not ask them again
    sessionStorage.removeItem(DESK_QUIZ_EMAIL_SKIPPED_KEY);
    sessionStorage.removeItem(DESK_QUIZ_EMAIL_VISIBLE_KEY);
    sessionStorage.removeItem(DESK_QUIZ_SKIP_FROM_KEY);
    sessionStorage.removeItem(DESK_QUIZ_TRAIL_KEY);
    sessionStorage.removeItem(DESK_QUIZ_KEYS_KEY);
  } catch (e) {}
}

function saveQuizQuestion(question, answer) {
  if (!question) return;

  var asked = getQuizQuestions();

  asked[question] = answer;

  try {
    sessionStorage.setItem(DESK_QUIZ_QUESTIONS_KEY, JSON.stringify(asked));
  } catch (e) {}
}

function getQuizQuestions() {
  try {
    return JSON.parse(sessionStorage.getItem(DESK_QUIZ_QUESTIONS_KEY)) || {};
  } catch (e) {
    return {};
  }
}
